import { Redirect } from 'expo-router'
import { FC } from 'react'

const Page: FC = () => {
    return <Redirect href="/archive/(tabs)" />
}

export default Page
